const TyreSizeFormatter = (function () {
    function format(tyreSize) {
        if (/^\d+-\d+-r\d+$/i.test(tyreSize)) {
            return tyreSize.replace("-", "/").replace("-r", "r").toUpperCase();
        }
        return tyreSize.toUpperCase();
    }

    return {format};
})();

export default TyreSizeFormatter;